/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Beitragsanteilbasiskrankenversicherung2Inputs */



/**

* @param {_Field_Beitragsanteilbasiskrankenversicherung2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_beitragsanteilbasiskrankenversicherung2 = /** @type {((inputs?: _Field_Beitragsanteilbasiskrankenversicherung2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Beitragsanteilbasiskrankenversicherung2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Monatl. Beitragsanteil Basiskrankenversicherung")
});
export { _field_beitragsanteilbasiskrankenversicherung2 as "_field_beitragsanteilBasisKrankenversicherung" }